import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Row, Col, Typography } from 'antd';
import { OnlineInventoryAPI } from '../../api/onlineInventoryAPI';
import { FormSelect, useCustomToast } from '../../../../components';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface ManageStateProps {
  visible: boolean;
  onClose: () => void;
  record: any;
  refetch?: () => void;
}

const ManageState: React.FC<ManageStateProps> = ({
  visible,
  onClose,
  record,
  refetch
}) => {
  const [form] = Form.useForm();
  const { showToast } = useCustomToast();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
    if (!visible || isLoading || !!record?.selectedRowKeys) return;
    
    setIsLoading(true);
    OnlineInventoryAPI.showVerification(record.inventory_id, record.id)
      .then(response => {
        form.setFieldsValue({ status: String(response?.new_good_status_id || '') });
        setIsEditable(response?.new_good_status_id);
      })
      .catch(error => {
        setIsEditable(false);
      })
      .finally(() => setIsLoading(false));
  }, [visible, record]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      const assets =
        Array.isArray(record?.selectedRowKeys)
          ? record.selectedRowKeys
          : [record?.id];

      const data = {
        inventory_id: record.inventory_id,
        new_status_id: values.status,
        assets
      };

      const response = await OnlineInventoryAPI.updateAssetStatuses(data);
      showToast('success', response?.message || 'Estado actualizado correctamente');
      refetch && refetch();
      onClose();
    } catch (error: any) {
      showToast(
        'error',
        error?.response?.data?.message ||
        'Error al actualizar el estado del inventario'
      );
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
    >
      
      <Row justify="center" style={{ marginBottom: 20 }}>
        <Col>
          <ExclamationCircleOutlined
            style={{ fontSize: 50, color: '#faad14' }}
          />
        </Col>
      </Row>
      <Form layout="vertical" form={form}>
        <Row justify="center" style={{ textAlign: 'center', marginBottom: 10 }}>
          <Col>
            <Text strong>¿Desea gestionar el estado del inventario?</Text>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={12}>
            <Form.Item
              name="status"
              rules={[{ required: true, message: 'Seleccione una opción' }]}
            >
              <FormSelect
                label="Estado"
                disabled={isEditable}
                name="status"
                value=""
                placeholder="Seleccione un estado"
                options={[
                  { name: 'Excelente', id: '40' },
                  { name: 'Bueno', id: '17' },
                  { name: 'Regular', id: '18' },
                  { name: 'Malo ', id: '19' },
                ]}
                onChange={() => {}}
                onBlur={() => {}}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center" gutter={16}>
          <Col>
            <Button onClick={onClose}>Cancelar</Button>
          </Col>
          <Col>
            {!isEditable ?<Button type="primary" onClick={handleSubmit}>
              Aceptar
            </Button> :
            <Button type="primary" onClick={() => setIsEditable(false)}>
              Editar
            </Button>}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ManageState;
